import { render, staticRenderFns } from "./PhotoswipeComponent.vue?vue&type=template&id=1133d7fa"
import script from "./PhotoswipeComponent.vue?vue&type=script&lang=js"
export * from "./PhotoswipeComponent.vue?vue&type=script&lang=js"
import style0 from "./PhotoswipeComponent.vue?vue&type=style&index=0&id=1133d7fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports